import ImgPirituba1 from '../assets/imagens/espaco/1.jpg';
import ImgPirituba2 from '../assets/imagens/espaco/2.jpg';
import ImgPirituba3 from '../assets/imagens/espaco/3.jpg';
import ImgPirituba4 from '../assets/imagens/espaco/4.jpg';
import ImgPirituba5 from '../assets/imagens/espaco/5.jpg';
import ImgFreguesia1 from '../assets/imagens/espaco/freguesia/1.jpg';
import ImgFreguesia2 from '../assets/imagens/espaco/freguesia/2.jpg';
import ImgFreguesia3 from '../assets/imagens/espaco/freguesia/3.jpg';

export const WHATSAPP_NUMBER = '551123660975';
export const WHATSAPP_DISPLAY = '(11) 2366-0975';
export const INSTAGRAM_URL = 'https://www.instagram.com/studio.corpoealma/';
export const FACEBOOK_URL = 'https://www.facebook.com/profile.php?id=100083936501561';

export type UnitId = 'pirituba' | 'freguesia';

export interface Unit {
  id: UnitId;
  name: string;
  neighborhood: string;
  shortLabel: string;
  ctaLabel: string;
  address: string;
  complement: string;
  cep: string;
  mapsUrl: string;
  mapsEmbed: string;
  photos: string[];
}

export const UNITS: Unit[] = [
  {
    id: 'pirituba',
    name: 'Unidade Pirituba',
    neighborhood: 'Pirituba',
    shortLabel: 'Unidade 1',
    ctaLabel: 'Quero Unidade Pirituba',
    address: 'Av. Mutinga, 239 - Sala 04',
    complement: 'Pirituba - São Paulo - SP',
    cep: '05154-000',
    mapsUrl: 'https://www.google.com/maps/search/?api=1&query=Av.+Mutinga,+239+-+Pirituba,+S%C3%A3o+Paulo+-+SP,+05154-000',
    mapsEmbed:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3659.2118653144976!2d-46.73169878558764!3d-23.488877164803355!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94cef93e39318cd3%3A0xa8cea6a858303cdc!2sAv.%20Mutinga%2C%20239%20-%20Jardim%20Libano%2C%20S%C3%A3o%20Paulo%20-%20SP%2C%2005154-000!5e0!3m2!1spt-BR!2sbr!4v1654025609701!5m2!1spt-BR!2sbr',
    photos: [ImgPirituba2, ImgPirituba1, ImgPirituba3, ImgPirituba4, ImgPirituba5],
  },
  {
    id: 'freguesia',
    name: 'Unidade Freguesia do Ó',
    neighborhood: 'Freguesia do Ó',
    shortLabel: 'Unidade 2',
    ctaLabel: 'Quero Unidade Freguesia do Ó',
    address: 'R. Bonifácio Cubas, 212 - Sala 03',
    complement: 'Freguesia do Ó - São Paulo - SP',
    cep: '02731-000',
    mapsUrl: 'https://www.google.com/maps/search/?api=1&query=R.+Bonif%C3%A1cio+Cubas,+212+-+Freguesia+do+%C3%93,+S%C3%A3o+Paulo+-+SP,+02731-000',
    mapsEmbed:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3658.8744210892282!2d-46.694246099999994!3d-23.5010323!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94cef848b653f549%3A0x54f2cb6eeca342dc!2sR.%20Bonif%C3%A1cio%20Cubas%2C%20212%20-%20Freguesia%20do%20%C3%93%2C%20S%C3%A3o%20Paulo%20-%20SP%2C%2002731-000!5e0!3m2!1spt-BR!2sbr!4v1750726986436!5m2!1spt-BR!2sbr',
    photos: [ImgFreguesia1, ImgFreguesia2, ImgFreguesia3],
  },
];

export const getUnit = (id: UnitId): Unit => UNITS.find((unit) => unit.id === id) as Unit;
